import { derived, writable } from 'svelte/store';
import { createSlotTimeLimits, createTimes, getPayload, isFunction, toLocalDate, setContent, identity, max, toSeconds, toISOString, sortEventChunks, addDuration, cloneDate, addDay, createDuration, datesEqual, helperEvent, toEventWithLocalDates, toViewWithLocalDates, task, resourceBackgroundColor, resourceTextColor, bgEvent, createEventClasses, createEventContent, height, keyEnter, subtractDuration, outsideRange, setPayload, ceil, rect, floor, runReposition, limitToRange, DAY_IN_SECONDS, eventIntersects, createEventChunk, debounce, btnTextDay, themeView, btnTextWeek, btnTextMonth, viewResources } from '@kokoro-calendar/core';
import 'svelte/internal/flags/legacy';
import * as $ from 'svelte/internal/client';
import { getContext, onMount, afterUpdate } from 'svelte';

// slotTimeLimits per day
function dayTimeLimits(state) {
    return derived(
        [state.slotMinTime, state.slotMaxTime, state.flexibleSlotTimeLimits, state._viewDates, state._events],
        ([$slotMinTime, $slotMaxTime, $flexibleSlotTimeLimits, $_viewDates, $_events]) => {
            let dayTimeLimits = {};
            for (let date of $_viewDates) {
                dayTimeLimits[date.getTime()] = createSlotTimeLimits(
                    $slotMinTime,
                    $slotMaxTime,
                    $flexibleSlotTimeLimits,
                    [date],
                    $_events
                );
            }

            return dayTimeLimits;
        }
    );
}

function dayTimes(state) {
    return derived(
        [state._viewDates, state.slotDuration, state._dayTimeLimits, state._intlSlotLabel],
        ([$_viewDates, $slotDuration, $_dayTimeLimits, $_intlSlotLabel]) => {
            let dayTimes = {};
            for (let date of $_viewDates) {
                let time = date.getTime();
                dayTimes[time] = time in $_dayTimeLimits
                    ? createTimes(date, $slotDuration, $_dayTimeLimits[time], $_intlSlotLabel)
                    : [];
            }

            return dayTimes;
        }
    );
}

function nestedResources(state) {
    return derived(state.resources, $resources => $resources.some(resource => getPayload(resource).children.length));
}

var root$7 = $.template(`<span></span>`);

function Label($$anchor, $$props) {
	$.push($$props, false);

	const [$$stores, $$cleanup] = $.setup_stores();
	const $resourceLabelContent = () => $.store_get(resourceLabelContent, '$resourceLabelContent', $$stores);
	const $resourceLabelDidMount = () => $.store_get(resourceLabelDidMount, '$resourceLabelDidMount', $$stores);
	let resource = $.prop($$props, 'resource', 8);
	let date = $.prop($$props, 'date', 8, undefined);
	let { resourceLabelContent, resourceLabelDidMount } = getContext('state');
	let el = $.mutable_state();
	let content = $.mutable_state();

	onMount(() => {
		if (isFunction($resourceLabelDidMount())) {
			$resourceLabelDidMount()({
				resource: resource(),
				date: date() ? toLocalDate(date()) : undefined,
				el: $.get(el)
			});
		}
	});

	$.legacy_pre_effect(
		() => (
			$resourceLabelContent(),
			$.deep_read_state(resource()),
			$.deep_read_state(date()),
			toLocalDate
		),
		() => {
			if ($resourceLabelContent()) {
				$.set(content, isFunction($resourceLabelContent())
					? $resourceLabelContent()({
						resource: resource(),
						date: date() ? toLocalDate(date()) : undefined
					})
					: $resourceLabelContent());
			} else {
				$.set(content, resource().title);
			}
		}
	);

	$.legacy_pre_effect_reset();
	$.init();

	var span = root$7();

	$.bind_this(span, ($$value) => $.set(el, $$value), () => $.get(el));
	$.action(span, ($$node, $$action_arg) => setContent?.($$node, $$action_arg), () => $.get(content));
	$.append($$anchor, span);
	$.pop();
	$$cleanup();
}

var root_1$4 = $.template(`<span></span>`);
var root_2$2 = $.template(`<button><!></button>`);
var root$6 = $.template(`<!> <span><!></span>`, 1);

function Expander($$anchor, $$props) {
	$.push($$props, false);

	const [$$stores, $$cleanup] = $.setup_stores();
	const $theme = () => $.store_get(theme, '$theme', $$stores);
	let resource = $.prop($$props, 'resource', 8);
	let { resources, theme } = getContext('state');
	let payload = $.mutable_state({});

	function handleClick() {
		$.mutate(payload, $.get(payload).expanded = !$.get(payload).expanded);
		toggle($.get(payload).children, $.get(payload).expanded);
		resources.update(identity);
	}

	function toggle(children, expand) {
		for (let child of children) {
			let payload = getPayload(child);

			payload.hidden = !expand;

			if (payload.expanded) {
				toggle(payload.children, expand);
			}
		}
	}

	$.legacy_pre_effect(
		() => (
			$.deep_read_state(resource())
		),
		() => {
			$.set(payload, getPayload(resource()));
		}
	);

	$.legacy_pre_effect_reset();
	$.init();

	var fragment = root$6();
	var node = $.first_child(fragment);

	$.each(node, 1, () => Array($.get(payload).level), $.index, ($$anchor, level) => {
		var span = root_1$4();

		$.template_effect(() => $.set_class(span, $theme().expander));
		$.append($$anchor, span);
	});

	var span_1 = $.sibling(node, 2);
	var node_1 = $.child(span_1);

	{
		var consequent_1 = ($$anchor) => {
			var button = root_2$2();
			var node_2 = $.child(button);

			{
				var consequent = ($$anchor) => {
					var text = $.text('−');

					$.append($$anchor, text);
				};

				var alternate = ($$anchor) => {
					var text_1 = $.text('+');

					$.append($$anchor, text_1);
				};

				$.if(node_2, ($$render) => {
					if ($.get(payload).expanded) $$render(consequent); else $$render(alternate, false);
				});
			}

			$.reset(button);
			$.template_effect(() => $.set_class(button, $theme().button));
			$.event('click', button, handleClick);
			$.append($$anchor, button);
		};

		$.if(node_1, ($$render) => {
			if ($.get(payload).children.length) $$render(consequent_1);
		});
	}

	$.reset(span_1);
	$.template_effect(() => $.set_class(span_1, $theme().expander));
	$.append($$anchor, fragment);
	$.pop();
	$$cleanup();
}

var root_1$3 = $.template(`<div role="rowheader"><!> <!></div>`);
var root$5 = $.template(`<div><div></div> <div></div></div>`);

function Sidebar($$anchor, $$props) {
	$.push($$props, false);

	const [$$stores, $$cleanup] = $.setup_stores();
	const $_headerEl = () => $.store_get(_headerEl, '$_headerEl', $$stores);
	const $theme = () => $.store_get(theme, '$theme', $$stores);
	const $_sidebarEl = () => $.store_get(_sidebarEl, '$_sidebarEl', $$stores);
	const $_viewResources = () => $.store_get(_viewResources, '$_viewResources', $$stores);
	const $_resHs = () => $.store_get(_resHs, '$_resHs', $$stores);
	const $_nestedResources = () => $.store_get(_nestedResources, '$_nestedResources', $$stores);

	let {
		_viewResources,
		_headerEl,
		_resHs,
		_sidebarEl,
		_nestedResources,
		theme
	} = getContext('state');

	let titleHeight = $.mutable_state(0);

	afterUpdate(() => {
		$.set(titleHeight, $_headerEl().clientHeight);
	});

	$.init();

	var div = root$5();
	var div_1 = $.child(div);
	var div_2 = $.sibling(div_1, 2);

	$.each(div_2, 5, $_viewResources, $.index, ($$anchor, resource) => {
		var div_3 = root_1$3();
		var node = $.child(div_3);

		{
			var consequent = ($$anchor) => {
				Expander($$anchor, {
					get resource() {
						return $.get(resource);
					}
				});
			};

			$.if(node, ($$render) => {
				if ($_nestedResources()) $$render(consequent);
			});
		}

		var node_1 = $.sibling(node, 2);

		Label(node_1, {
			get resource() {
				return $.get(resource);
			}
		});

		$.reset(div_3);

		$.template_effect(
			($0) => {
				$.set_class(div_3, $theme().resource);
				$.set_attribute(div_3, 'style', `flex-basis: ${$0 ?? ''}px`);
			},
			[
				() => max($_resHs().get($.get(resource)) ?? 0, 34)
			],
			$.derived_safe_equal
		);

		$.append($$anchor, div_3);
	});

	$.reset(div_2);
	$.bind_this(div_2, ($$value) => $.store_set(_sidebarEl, $$value), () => $_sidebarEl());
	$.reset(div);

	$.template_effect(() => {
		$.set_class(div, $theme().sidebar);
		$.set_class(div_1, $theme().sidebarTitle);
		$.set_attribute(div_1, 'style', `flex-basis: ${$.get(titleHeight) ?? ''}px`);
		$.set_class(div_2, $theme().content);
	});

	$.append($$anchor, div);
	$.pop();
	$$cleanup();
}

var root_3 = $.template(`<div role="columnheader"><time></time></div>`);
var root_2$1 = $.template(`<div><time></time></div> <div></div>`, 1);
var root_4 = $.template(`<div role="columnheader"><time></time></div>`);
var root_1$2 = $.template(`<div><!></div>`);
var root$4 = $.template(`<div><div role="row"></div> <div></div></div>`);

function Header($$anchor, $$props) {
	$.push($$props, false);

	const [$$stores, $$cleanup] = $.setup_stores();
	const $theme = () => $.store_get(theme, '$theme', $$stores);
	const $_headerEl = () => $.store_get(_headerEl, '$_headerEl', $$stores);
	const $_viewDates = () => $.store_get(_viewDates, '$_viewDates', $$stores);
	const $slotDuration = () => $.store_get(slotDuration, '$slotDuration', $$stores);
	const $_intlDayHeaderAL = () => $.store_get(_intlDayHeaderAL, '$_intlDayHeaderAL', $$stores);
	const $_intlDayHeader = () => $.store_get(_intlDayHeader, '$_intlDayHeader', $$stores);
	const $_dayTimes = () => $.store_get(_dayTimes, '$_dayTimes', $$stores);

	let {
		_headerEl,
		_intlDayHeader,
		_intlDayHeaderAL,
		_dayTimes,
		_viewDates,
		slotDuration,
		theme
	} = getContext('state');

	$.init();

	var div = root$4();
	var div_1 = $.child(div);

	$.each(div_1, 5, $_viewDates, $.index, ($$anchor, date) => {
		var div_2 = root_1$2();
		var node = $.child(div_2);

		{
			var consequent = ($$anchor) => {
				var fragment = root_2$1();
				var div_3 = $.first_child(fragment);
				var time_1 = $.child(div_3);

				$.action(time_1, ($$node, $$action_arg) => setContent?.($$node, $$action_arg), () => $_intlDayHeader().format($.get(date)));
				$.reset(div_3);

				var div_4 = $.sibling(div_3, 2);

				$.each(div_4, 5, () => $_dayTimes()[$.get(date).getTime()], $.index, ($$anchor, time) => {
					var div_5 = root_3();
					var time_2 = $.child(div_5);

					$.action(time_2, ($$node, $$action_arg) => setContent?.($$node, $$action_arg), () => $.get(time)[1]);
					$.reset(div_5);

					$.template_effect(() => {
						$.set_class(div_5, $theme().time);
						$.set_attribute(time_2, 'datetime', $.get(time)[0]);
					});

					$.append($$anchor, div_5);
				});

				$.reset(div_4);

				$.template_effect(
					($0, $1) => {
						$.set_class(div_3, $theme().dayHead);
						$.set_attribute(time_1, 'datetime', $0);
						$.set_attribute(time_1, 'aria-label', $1);
						$.set_class(div_4, $theme().times);
					},
					[
						() => toISOString($.get(date), 10),
						() => $_intlDayHeaderAL().format($.get(date))
					],
					$.derived_safe_equal
				);

				$.append($$anchor, fragment);
			};

			var alternate = ($$anchor) => {
				var div_6 = root_4();
				var time_3 = $.child(div_6);

				$.action(time_3, ($$node, $$action_arg) => setContent?.($$node, $$action_arg), () => $_intlDayHeader().format($.get(date)));
				$.reset(div_6);

				$.template_effect(
					($0, $1) => {
						$.set_class(div_6, $theme().time);
						$.set_attribute(time_3, 'datetime', $0);
						$.set_attribute(time_3, 'aria-label', $1);
					},
					[
						() => toISOString($.get(date), 10),
						() => $_intlDayHeaderAL().format($.get(date))
					],
					$.derived_safe_equal
				);

				$.append($$anchor, div_6);
			};

			$.if(node, ($$render) => {
				if (toSeconds($slotDuration())) $$render(consequent); else $$render(alternate, false);
			});
		}

		$.reset(div_2);

		$.template_effect(
			($0) => $.set_class(div_2, `${$theme().day ?? ''} ${$0 ?? ''}`),
			[
				() => $theme().weekdays?.[$.get(date).getUTCDay()]
			],
			$.derived_safe_equal
		);

		$.append($$anchor, div_2);
	});

	$.reset(div_1);

	var div_7 = $.sibling(div_1, 2);

	$.reset(div);
	$.bind_this(div, ($$value) => $.store_set(_headerEl, $$value), () => $_headerEl());

	$.template_effect(() => {
		$.set_class(div, $theme().header);
		$.set_class(div_1, $theme().days);
		$.set_class(div_7, $theme().hiddenScroll);
	});

	$.append($$anchor, div);
	$.pop();
	$$cleanup();
}

function prepareEventChunks(chunks, $_viewDates, $_dayTimeLimits, $slotDuration) {
    let longChunks = {};
    let filteredChunks = [];

    if (chunks.length) {
        sortEventChunks(chunks);

        let step = toSeconds($slotDuration);
        let prevChunk;
        for (let chunk of chunks) {
            let prevDayEnd;
            if (step) {
                let slots = 0;
                for (let i = 0; i < $_viewDates.length; ++i) {
                    let slotTimeLimits = getSlotTimeLimits($_dayTimeLimits, $_viewDates[i]);
                    let dayStart = addDuration(cloneDate($_viewDates[i]), slotTimeLimits.min);
                    let dayEnd = addDuration(cloneDate($_viewDates[i]), slotTimeLimits.max);
                    if (!chunk.date) {
                        if (chunk.start < dayEnd && chunk.end > dayStart) {
                            // The first day is found
                            chunk.date = $_viewDates[i];
                            if (chunk.start < dayStart) {
                                // Adjust chunk start
                                chunk.start = dayStart;
                            }
                            // Calculate offset
                            chunk.offset = (chunk.start - dayStart) / 1000 / step;
                            // Calculate slots
                            if (chunk.end > dayEnd) {
                                slots += dayEnd - chunk.start;
                            } else {
                                slots += max(chunk.end - chunk.start, step * 1000);
                                break;
                            }
                        }
                    } else {
                        if (chunk.end <= dayStart) {
                            // Adjust chunk end
                            chunk.end = prevDayEnd;
                            break;
                        }
                        // The chunk is long one
                        let key = $_viewDates[i].getTime();
                        if (longChunks[key]) {
                            longChunks[key].push(chunk);
                        } else {
                            longChunks[key] = [chunk];
                        }
                        // Calculate slots
                        if (chunk.end > dayEnd) {
                            slots += dayEnd - dayStart;
                        } else {
                            slots += chunk.end - dayStart;
                            break;
                        }
                    }
                    prevDayEnd = dayEnd;
                }
                chunk.slots = slots / 1000 / step;
            } else {
                // Month view
                let days = 0;
                for (let i = 0; i < $_viewDates.length; ++i) {
                    let dayStart = $_viewDates[i];
                    let dayEnd = addDay(cloneDate(dayStart));
                    if (!chunk.date) {
                        if (chunk.start < dayEnd) {
                            // The first day is found
                            chunk.date = dayStart;
                            if (chunk.start < dayStart) {
                                // Adjust chunk start
                                chunk.start = dayStart;
                            }
                            ++days;
                        }
                    } else {
                        if (chunk.end <= dayStart) {
                            // Adjust chunk end
                            chunk.end = prevDayEnd;
                            break;
                        }
                        // The chunk is long one
                        let key = dayStart.getTime();
                        if (longChunks[key]) {
                            longChunks[key].push(chunk);
                        } else {
                            longChunks[key] = [chunk];
                        }
                        ++days;
                    }
                    prevDayEnd = dayEnd;
                }
                chunk.days = days;
            }

            if (!chunk.date) {
                // Chunk is outside the slot time limits, so skip it
                continue;
            }

            if (prevChunk && datesEqual(prevChunk.date, chunk.date)) {
                chunk.prev = prevChunk;
            }
            prevChunk = chunk;
            filteredChunks.push(chunk);
        }
    }

    return [filteredChunks, longChunks];
}

function repositionEvent(chunk, dayChunks, longChunks, height, allDay) {
    chunk.top = 0;
    chunk.bottom = height;
    let margin = 1;
    let key = chunk.date.getTime();
    longChunks = longChunks?.[key] ?? [];
    let chunks = [...dayChunks, ...longChunks];
    chunks.sort((a, b) => (a.top ?? 0) - (b.top ?? 0) || a.start - b.start || b.event.allDay - a.event.allDay);
    for (let dayChunk of chunks) {
        if (dayChunk === chunk) {
            continue;
        }
        if ((allDay || chunk.start < dayChunk.end && chunk.end > dayChunk.start) && chunk.top < dayChunk.bottom && chunk.bottom > dayChunk.top) {
            let offset = dayChunk.bottom - chunk.top + 1;
            margin += offset;
            chunk.top += offset;
            chunk.bottom += offset;
        }
    }

    return margin;
}

function getSlotTimeLimits($_dayTimeLimits, date) {
    return $_dayTimeLimits[date.getTime()] ?? { min: createDuration(0), max: createDuration(0) };
}

var root_1$1 = $.template(`<article><!> <div></div> <!></article>`);

function Event($$anchor, $$props) {
	$.push($$props, false);

	const [$$stores, $$cleanup] = $.setup_stores();
	const $slotWidth = () => $.store_get(slotWidth, '$slotWidth', $$stores);
	const $resources = () => $.store_get(resources, '$resources', $$stores);
	const $eventBackgroundColor = () => $.store_get(eventBackgroundColor, '$eventBackgroundColor', $$stores);
	const $eventColor = () => $.store_get(eventColor, '$eventColor', $$stores);
	const $eventTextColor = () => $.store_get(eventTextColor, '$eventTextColor', $$stores);
	const $theme = () => $.store_get(theme, '$theme', $$stores);
	const $_iClasses = () => $.store_get(_iClasses, '$_iClasses', $$stores);
	const $eventClassNames = () => $.store_get(eventClassNames, '$eventClassNames', $$stores);
	const $_view = () => $.store_get(_view, '$_view', $$stores);
	const $displayEventEnd = () => $.store_get(displayEventEnd, '$displayEventEnd', $$stores);
	const $eventContent = () => $.store_get(eventContent, '$eventContent', $$stores);
	const $_intlEventTime = () => $.store_get(_intlEventTime, '$_intlEventTime', $$stores);
	const $eventDidMount = () => $.store_get(eventDidMount, '$eventDidMount', $$stores);
	const $eventAllUpdated = () => $.store_get(eventAllUpdated, '$eventAllUpdated', $$stores);
	const $slotDuration = () => $.store_get(slotDuration, '$slotDuration', $$stores);
	const $eventClick = () => $.store_get(eventClick, '$eventClick', $$stores);
	const $eventMouseEnter = () => $.store_get(eventMouseEnter, '$eventMouseEnter', $$stores);
	const $eventMouseLeave = () => $.store_get(eventMouseLeave, '$eventMouseLeave', $$stores);
	const $_interaction = () => $.store_get(_interaction, '$_interaction', $$stores);
	let chunk = $.prop($$props, 'chunk', 8);
	let dayChunks = $.prop($$props, 'dayChunks', 24, () => []);
	let longChunks = $.prop($$props, 'longChunks', 24, () => ({}));
	let resource = $.prop($$props, 'resource', 8, undefined);

	let {
		displayEventEnd,
		eventAllUpdated,
		eventBackgroundColor,
		eventTextColor,
		eventColor,
		eventContent,
		eventClick,
		eventDidMount,
		eventClassNames,
		eventMouseEnter,
		eventMouseLeave,
		resources,
		slotDuration,
		slotWidth,
		theme,
		_view,
		_intlEventTime,
		_interaction,
		_iClasses,
		_tasks
	} = getContext('state');

	let el = $.mutable_state();
	let event = $.mutable_state();
	let display = $.mutable_state();
	let classes = $.mutable_state();
	let style = $.mutable_state();
	let content = $.mutable_state();
	let timeText = $.mutable_state();
	let onclick = $.mutable_state();
	let margin = $.mutable_state(helperEvent(chunk().event.display) ? 1 : 0);
	let width = $.mutable_state(0);

	onMount(() => {
		if (isFunction($eventDidMount())) {
			$eventDidMount()({
				event: toEventWithLocalDates($.get(event)),
				timeText: $.get(timeText),
				el: $.get(el),
				view: toViewWithLocalDates($_view())
			});
		}
	});

	afterUpdate(() => {
		if (isFunction($eventAllUpdated()) && !helperEvent($.get(display))) {
			task(() => $eventAllUpdated()({ view: toViewWithLocalDates($_view()) }), 'eau', _tasks);
		}
	});

	function createHandler(fn, display) {
		return !helperEvent(display) && isFunction(fn)
			? (jsEvent) => fn({
				event: toEventWithLocalDates($.get(event)),
				el: $.get(el),
				jsEvent,
				view: toViewWithLocalDates($_view())
			})
			: undefined;
	}

	function createDragHandler(interaction, resize) {
		return interaction.action ? (jsEvent) => interaction.action.drag($.get(event), jsEvent, resize, resize && chunk().zeroDuration ? subtractDuration(cloneDate($.get(event).end), $slotDuration()) : undefined, [$.get(margin), resource()], chunk().zeroDuration) : undefined;
	}

	function reposition() {
		if (!$.get(el)) {
			return 0;
		}

		let h = height($.get(el));

		$.set(margin, repositionEvent(chunk(), dayChunks(), longChunks(), h, !toSeconds($slotDuration())));
		return $.get(margin) + h;
	}

	$.legacy_pre_effect(() => ($.deep_read_state(chunk())), () => {
		$.set(event, chunk().event);
	});

	$.legacy_pre_effect(
		() => (
			$.get(display),
			$.get(event),
			$.deep_read_state(chunk()),
			$slotWidth(),
			$.get(width),
			$.get(style),
			$resources(),
			$eventBackgroundColor(),
			$eventColor(),
			$eventTextColor(),
			$.get(margin),
			$.deep_read_state(resource()),
			$theme(),
			$_iClasses(),
			$eventClassNames(),
			$_view()
		),
		() => {
			$.set(display, $.get(event).display);

			// Style
			if ('slots' in chunk()) {
				let left = chunk().offset * $slotWidth();

				$.set(width, chunk().slots * $slotWidth());
				$.set(style, `left:${left}px;` + `width:${$.get(width)}px;`);
			} else {
				// Month view
				$.set(width, chunk().days * 100);
				$.set(style, `width:${$.get(width)}%;`);
			}

			let bgColor = $.get(event).backgroundColor || resourceBackgroundColor($.get(event), $resources()) || $eventBackgroundColor() || $eventColor();
			let txtColor = $.get(event).textColor || resourceTextColor($.get(event), $resources()) || $eventTextColor();
			let marginTop = $.get(margin);

			if ($.get(event)._margin) {
				// Force margin for helper events
				let [_margin, _resource] = $.get(event)._margin;

				if (resource() === _resource) {
					marginTop = _margin;
				}
			}

			$.set(style, $.get(style) + `margin-top:${marginTop}px;`);

			if (bgColor) {
				$.set(style, $.get(style) + `background-color:${bgColor};`);
			}

			if (txtColor) {
				$.set(style, $.get(style) + `color:${txtColor};`);
			}

			$.set(style, $.get(style) + $.get(event).styles.join(';'));

			// Class
			$.set(classes, [
				bgEvent($.get(display)) ? $theme().bgEvent : $theme().event,
				...$_iClasses()([], $.get(event)),
				...createEventClasses($eventClassNames(), $.get(event), $_view())
			].join(' '));
		}
	);

	$.legacy_pre_effect(
		() => (
			$.get(timeText),
			$.get(content),
			$.deep_read_state(chunk()),
			$displayEventEnd(),
			$eventContent(),
			$theme(),
			$_intlEventTime(),
			$_view()
		),
		() => {
			(($$value) => (
				$.set(timeText, $$value[0]),
				$.set(content, $$value[1])
			))(createEventContent(chunk(), $displayEventEnd(), $eventContent(), $theme(), $_intlEventTime(), $_view()));
		}
	);

	$.legacy_pre_effect(
		() => (
			$.get(display),
			$eventClick()
		),
		() => {
			$.set(onclick, !bgEvent($.get(display)) && createHandler($eventClick(), $.get(display)));
		}
	);

	$.legacy_pre_effect_reset();
	$.init();

	var fragment = $.comment();
	var node = $.first_child(fragment);

	{
		var consequent = ($$anchor) => {
			var article = root_1$1();
			var event_handler = $.derived(() => $.get(onclick) && keyEnter($.get(onclick)));
			var event_handler_1 = $.derived(() => createHandler($eventMouseEnter(), $.get(display)));
			var event_handler_2 = $.derived(() => createHandler($eventMouseLeave(), $.get(display)));
			var event_handler_3 = $.derived(() => !bgEvent($.get(display)) && !helperEvent($.get(display)) && createDragHandler($_interaction()));
			var node_1 = $.child(article);
			var event_handler_4 = $.derived(() => createDragHandler($_interaction(), ['x', 'start']));

			$.component(node_1, () => $_interaction().resizer, ($$anchor, $$component) => {
				$$component($$anchor, {
					start: true,
					get event() {
						return $.get(event);
					},
					$$events: {
						pointerdown(...$$args) {
							$.get(event_handler_4)?.apply(this, $$args);
						}
					}
				});
			});

			var div = $.sibling(node_1, 2);

			$.action(div, ($$node, $$action_arg) => setContent?.($$node, $$action_arg), () => $.get(content));

			var node_2 = $.sibling(div, 2);
			var event_handler_5 = $.derived(() => createDragHandler($_interaction(), ['x', 'end']));

			$.component(node_2, () => $_interaction().resizer, ($$anchor, $$component) => {
				$$component($$anchor, {
					get event() {
						return $.get(event);
					},
					$$events: {
						pointerdown(...$$args) {
							$.get(event_handler_5)?.apply(this, $$args);
						}
					}
				});
			});

			$.reset(article);
			$.bind_this(article, ($$value) => $.set(el, $$value), () => $.get(el));

			$.template_effect(() => {
				$.set_class(article, $.get(classes));
				$.set_attribute(article, 'style', $.get(style));
				$.set_attribute(article, 'role', $.get(onclick) ? 'button' : undefined);
				$.set_attribute(article, 'tabindex', $.get(onclick) ? 0 : undefined);
				$.set_class(div, $theme().eventBody);
			});

			$.event('click', article, function (...$$args) {
				$.get(onclick)?.apply(this, $$args);
			});

			$.event('keydown', article, function (...$$args) {
				$.get(event_handler)?.apply(this, $$args);
			});

			$.event('mouseenter', article, function (...$$args) {
				$.get(event_handler_1)?.apply(this, $$args);
			});

			$.event('mouseleave', article, function (...$$args) {
				$.get(event_handler_2)?.apply(this, $$args);
			});

			$.event('pointerdown', article, function (...$$args) {
				$.get(event_handler_3)?.apply(this, $$args);
			});

			$.append($$anchor, article);
		};

		$.if(node, ($$render) => {
			if ($.get(width) > 0) $$render(consequent);
		});
	}

	$.append($$anchor, fragment);
	$.bind_prop($$props, 'reposition', reposition);

	var $$pop = $.pop({ reposition });

	$$cleanup();
	return $$pop;
}

var root_1 = $.template(`<!> <!> <!> <!>`, 1);
var root$3 = $.template(`<div role="cell"><div><!></div></div>`);

function Day($$anchor, $$props) {
	$.push($$props, false);

	const [$$stores, $$cleanup] = $.setup_stores();
	const $_today = () => $.store_get(_today, '$_today', $$stores);
	const $highlightedDates = () => $.store_get(highlightedDates, '$highlightedDates', $$stores);
	const $validRange = () => $.store_get(validRange, '$validRange', $$stores);
	const $_dayTimeLimits = () => $.store_get(_dayTimeLimits, '$_dayTimeLimits', $$stores);
	const $slotDuration = () => $.store_get(slotDuration, '$slotDuration', $$stores);
	const $slotWidth = () => $.store_get(slotWidth, '$slotWidth', $$stores);
	const $theme = () => $.store_get(theme, '$theme', $$stores);
	const $_interaction = () => $.store_get(_interaction, '$_interaction', $$stores);
	let date = $.prop($$props, 'date', 8);
	let resource = $.prop($$props, 'resource', 8);
	let chunks = $.prop($$props, 'chunks', 8);
	let bgChunks = $.prop($$props, 'bgChunks', 8);
	let longChunks = $.prop($$props, 'longChunks', 8);
	let iChunks = $.prop($$props, 'iChunks', 24, () => []);

	let {
		highlightedDates,
		slotDuration,
		slotWidth,
		theme,
		validRange,
		_interaction,
		_today,
		_dayTimeLimits
	} = getContext('state');

	let el = $.mutable_state();

	let dayChunks = $.mutable_state(),
		dayBgChunks = $.mutable_state();

	let isToday = $.mutable_state(),
		highlight = $.mutable_state(),
		disabled = $.mutable_state();

	let refs = $.mutable_state([]);
	let slotTimeLimits = $.mutable_state();
	let allDay = $.mutable_state();
	let pointerIdx = $.mutable_state(1);

	function chunkIntersects(chunk) {
		return datesEqual(chunk.date, date());
	}

	function dateFromPoint(x, y) {
		x -= rect($.get(el)).left;

		return {
			allDay: $.get(allDay),
			date: $.get(allDay) ? cloneDate(date()) : addDuration(addDuration(cloneDate(date()), $.get(slotTimeLimits).min), $slotDuration(), floor(x / $slotWidth())),
			resource: resource(),
			dayEl: $.get(el),
			disabled: $.get(disabled)
		};
	}

	function reposition() {
		return max(...runReposition($.get(refs), $.get(dayChunks)));
	}

	$.legacy_pre_effect(
		() => (
			$.deep_read_state(date()),
			$_today()
		),
		() => {
			$.set(isToday, datesEqual(date(), $_today()));
		}
	);

	$.legacy_pre_effect(
		() => (
			$highlightedDates(),
			$.deep_read_state(date())
		),
		() => {
			$.set(highlight, $highlightedDates().some((d) => datesEqual(d, date())));
		}
	);

	$.legacy_pre_effect(
		() => (
			$.deep_read_state(date()),
			$validRange()
		),
		() => {
			$.set(disabled, outsideRange(date(), $validRange()));
		}
	);

	$.legacy_pre_effect(
		() => (
			$_dayTimeLimits(),
			$.deep_read_state(date())
		),
		() => {
			$.set(slotTimeLimits, getSlotTimeLimits($_dayTimeLimits(), date()));
		}
	);

	$.legacy_pre_effect(
		() => (
			$.get(allDay),
			$slotDuration()
		),
		() => {
			$.set(allDay, !toSeconds($slotDuration()));
			$.set(pointerIdx, $.get(allDay) ? 2 : 1);
		}
	);

	$.legacy_pre_effect(() => ($.deep_read_state(chunks())), () => {
		$.set(dayChunks, chunks().filter(chunkIntersects));
	});

	$.legacy_pre_effect(
		() => (
			$.deep_read_state(bgChunks()),
			$.get(allDay)
		),
		() => {
			$.set(dayBgChunks, bgChunks().filter((bgChunk) => (!$.get(allDay) || bgChunk.event.allDay) && chunkIntersects(bgChunk)));
		}
	);

	$.legacy_pre_effect(() => ($.get(el), setPayload), () => {
		if ($.get(el)) {
			setPayload($.get(el), dateFromPoint);
		}
	});

	$.legacy_pre_effect_reset();
	$.init();

	var div = root$3();
	var div_1 = $.child(div);
	var node = $.child(div_1);

	{
		var consequent_2 = ($$anchor) => {
			var fragment = root_1();
			var node_1 = $.first_child(fragment);

			$.each(node_1, 1, () => $.get(dayBgChunks), (chunk) => chunk.event, ($$anchor, chunk) => {
				Event($$anchor, {
					get chunk() {
						return $.get(chunk);
					}
				});
			});

			var node_2 = $.sibling(node_1, 2);

			{
				var consequent = ($$anchor) => {
					Event($$anchor, {
						get chunk() {
							return iChunks()[$.get(pointerIdx)];
						}
					});
				};

				$.if(node_2, ($$render) => {
					if (iChunks()[$.get(pointerIdx)] && chunkIntersects(iChunks()[$.get(pointerIdx)])) $$render(consequent);
				});
			}

			var node_3 = $.sibling(node_2, 2);

			$.each(node_3, 3, () => $.get(dayChunks), (chunk) => chunk.event, ($$anchor, chunk, i) => {
				$.bind_this(
					Event($$anchor, {
						get chunk() {
							return $.get(chunk);
						},
						get dayChunks() {
							return $.get(dayChunks);
						},
						get longChunks() {
							return longChunks();
						},
						get resource() {
							return resource();
						},
						$$legacy: true
					}),
					($$value, i) => $.mutate(refs, $.get(refs)[i] = $$value),
					(i) => $.get(refs)?.[i],
					() => [$.get(i)]
				);
			});

			var node_4 = $.sibling(node_3, 2);

			{
				var consequent_1 = ($$anchor) => {
					Event($$anchor, {
						get chunk() {
							return iChunks()[0];
						},
						get resource() {
							return resource();
						}
					});
				};

				$.if(node_4, ($$render) => {
					if (iChunks()[0] && chunkIntersects(iChunks()[0])) $$render(consequent_1);
				});
			}

			$.append($$anchor, fragment);
		};

		$.if(node, ($$render) => {
			if (!$.get(disabled)) $$render(consequent_2);
		});
	}

	$.reset(div_1);
	$.reset(div);
	$.bind_this(div, ($$value) => $.set(el, $$value), () => $.get(el));

	$.template_effect(
		($0, $1) => {
			$.set_class(div, `${$theme().day ?? ''} ${$0 ?? ''}${($.get(isToday) ? ' ' + $theme().today : '') ?? ''}${($.get(highlight) ? ' ' + $theme().highlight : '') ?? ''}${($.get(disabled) ? ' ' + $theme().disabled : '') ?? ''}`);
			$.set_attribute(div, 'style', `flex-grow: ${$1 ?? ''}`);
			$.set_class(div_1, $theme().events);
		},
		[
			() => $theme().weekdays?.[date().getUTCDay()],
			() => $.get(allDay) ? null : ceil((toSeconds($.get(slotTimeLimits).max) - toSeconds($.get(slotTimeLimits).min)) / toSeconds($slotDuration()))
		],
		$.derived_safe_equal
	);

	$.event('pointerdown', div, function (...$$args) {
		$_interaction().action?.select?.apply(this, $$args);
	});

	$.append($$anchor, div);
	$.bind_prop($$props, 'reposition', reposition);

	var $$pop = $.pop({ reposition });

	$$cleanup();
	return $$pop;
}

var root$2 = $.template(`<div role="row"></div>`);

function Days($$anchor, $$props) {
	$.push($$props, false);

	const [$$stores, $$cleanup] = $.setup_stores();
	const $_viewDates = () => $.store_get(_viewDates, '$_viewDates', $$stores);
	const $validRange = () => $.store_get(validRange, '$validRange', $$stores);
	const $_dayTimeLimits = () => $.store_get(_dayTimeLimits, '$_dayTimeLimits', $$stores);
	const $_resHs = () => $.store_get(_resHs, '$_resHs', $$stores);
	const $_events = () => $.store_get(_events, '$_events', $$stores);
	const $slotDuration = () => $.store_get(slotDuration, '$slotDuration', $$stores);
	const $_iEvents = () => $.store_get(_iEvents, '$_iEvents', $$stores);
	const $theme = () => $.store_get(theme, '$theme', $$stores);
	let resource = $.prop($$props, 'resource', 8);

	let {
		_viewDates,
		_events,
		_iEvents,
		_queue2,
		_resHs,
		_dayTimeLimits,
		slotDuration,
		theme,
		validRange
	} = getContext('state');

	let chunks = $.mutable_state(),
		bgChunks = $.mutable_state(),
		longChunks = $.mutable_state(),
		iChunks = $.mutable_state([]);

	let start = $.mutable_state();
	let end = $.mutable_state();
	let refs = $.mutable_state([]);
	let height = $.mutable_state(0);
	let debounceHandle = {};

	function reposition() {
		debounce(
			() => {
				$.set(height, ceil(max(...runReposition($.get(refs), $_viewDates()))) + 10);
				$_resHs().set(resource(), $.get(height));
				$.store_set(_resHs, $_resHs());
			},
			debounceHandle,
			_queue2
		);
	}

	$.legacy_pre_effect(
		() => (
			$.get(start),
			$_viewDates(),
			$validRange(),
			$.get(end),
			$_dayTimeLimits(),
			addDay
		),
		() => {
			$.set(start, cloneDate(limitToRange($_viewDates()[0], $validRange())));
			$.set(end, cloneDate(limitToRange($_viewDates().at(-1), $validRange())));

			let slotTimeLimits = getSlotTimeLimits($_dayTimeLimits(), $.get(start));

			addDuration($.get(start), slotTimeLimits.min);
			slotTimeLimits = getSlotTimeLimits($_dayTimeLimits(), $.get(end));
			slotTimeLimits.max.seconds > DAY_IN_SECONDS ? addDuration($.get(end), slotTimeLimits.max) : addDay($.get(end)); /** @see https://github.com/vkurko/calendar/issues/333 */
		}
	);

	$.legacy_pre_effect(
		() => (
			$.get(chunks),
			$.get(bgChunks),
			$_events(),
			$.get(start),
			$.get(end),
			$.deep_read_state(resource()),
			$_viewDates(),
			$_dayTimeLimits(),
			$slotDuration(),
			$.get(longChunks)
		),
		() => {
			$.set(chunks, []);
			$.set(bgChunks, []);

			for (let event of $_events()) {
				if (eventIntersects(event, $.get(start), $.get(end), resource())) {
					let chunk = createEventChunk(event, $.get(start), $.get(end));

					if (bgEvent(event.display)) {
						$.get(bgChunks).push(chunk);
					} else {
						$.get(chunks).push(chunk);
					}
				}
			}

			(($$value) => ($.set(bgChunks, $$value[0])))(prepareEventChunks($.get(bgChunks), $_viewDates(), $_dayTimeLimits(), $slotDuration()));

			(($$value) => (
				$.set(chunks, $$value[0]),
				$.set(longChunks, $$value[1])
			))(prepareEventChunks($.get(chunks), $_viewDates(), $_dayTimeLimits(), $slotDuration()));

			// Run reposition only when events get changed
			reposition();
		}
	);

	$.legacy_pre_effect(
		() => (
			$_iEvents(),
			$.get(start),
			$.get(end),
			$.deep_read_state(resource()),
			$_viewDates(),
			$_dayTimeLimits(),
			$slotDuration()
		),
		() => {
			$.set(iChunks, $_iEvents().map((event) => {
				let chunk;

				if (event && eventIntersects(event, $.get(start), $.get(end), resource())) {
					chunk = createEventChunk(event, $.get(start), $.get(end));
					[[chunk]] = prepareEventChunks([chunk], $_viewDates(), $_dayTimeLimits(), $slotDuration());
				} else {
					chunk = null;
				}

				return chunk;
			}));
		}
	);

	$.legacy_pre_effect_reset();
	$.init();

	var div = root$2();

	$.event('resize', $.window, reposition);

	$.each(div, 5, $_viewDates, $.index, ($$anchor, date, i) => {
		$.bind_this(
			Day($$anchor, {
				get date() {
					return $.get(date);
				},
				get resource() {
					return resource();
				},
				get chunks() {
					return $.get(chunks);
				},
				get bgChunks() {
					return $.get(bgChunks);
				},
				get longChunks() {
					return $.get(longChunks);
				},
				get iChunks() {
					return $.get(iChunks);
				},
				$$legacy: true
			}),
			($$value, i) => $.mutate(refs, $.get(refs)[i] = $$value),
			(i) => $.get(refs)?.[i],
			() => [i]
		);
	});

	$.reset(div);

	$.template_effect(
		($0) => {
			$.set_class(div, $theme().days);
			$.set_attribute(div, 'style', `flex-basis: ${$0 ?? ''}px`);
		},
		[() => max($.get(height), 34)],
		$.derived_safe_equal
	);

	$.append($$anchor, div);
	$.pop();
	$$cleanup();
}

var root_2 = $.template(`<div></div>`);
var root$1 = $.template(`<div><div><div></div> <!></div></div>`);

function Body($$anchor, $$props) {
	$.push($$props, false);

	const [$$stores, $$cleanup] = $.setup_stores();
	const $_bodyEl = () => $.store_get(_bodyEl, '$_bodyEl', $$stores);
	const $_headerEl = () => $.store_get(_headerEl, '$_headerEl', $$stores);
	const $_sidebarEl = () => $.store_get(_sidebarEl, '$_sidebarEl', $$stores);
	const $_viewDates = () => $.store_get(_viewDates, '$_viewDates', $$stores);
	const $scrollTime = () => $.store_get(scrollTime, '$scrollTime', $$stores);
	const $_dayTimeLimits = () => $.store_get(_dayTimeLimits, '$_dayTimeLimits', $$stores);
	const $slotDuration = () => $.store_get(slotDuration, '$slotDuration', $$stores);
	const $slotWidth = () => $.store_get(slotWidth, '$slotWidth', $$stores);
	const $theme = () => $.store_get(theme, '$theme', $$stores);
	const $_dayTimes = () => $.store_get(_dayTimes, '$_dayTimes', $$stores);
	const $_viewResources = () => $.store_get(_viewResources, '$_viewResources', $$stores);

	let {
		_bodyEl,
		_headerEl,
		_sidebarEl,
		_dayTimes,
		_dayTimeLimits,
		_viewResources,
		_viewDates,
		scrollTime,
		slotDuration,
		slotWidth,
		theme
	} = getContext('state');

	let el = $.mutable_state();

	function handleScroll() {
		$.store_mutate(_headerEl, $.untrack($_headerEl).scrollLeft = $_bodyEl().scrollLeft, $.untrack($_headerEl));
		$.store_mutate(_sidebarEl, $.untrack($_sidebarEl).scrollTop = $_bodyEl().scrollTop, $.untrack($_sidebarEl));
	}

	function scrollToTime() {
		let slotTimeLimits = getSlotTimeLimits($_dayTimeLimits(), $_viewDates()[0]);

		$.mutate(el, $.get(el).scrollLeft = (toSeconds($scrollTime()) - toSeconds(slotTimeLimits.min)) / toSeconds($slotDuration()) * $slotWidth());
	}

	$.legacy_pre_effect(() => ($.get(el)), () => {
		$.store_set(_bodyEl, $.get(el));
	});

	$.legacy_pre_effect(
		() => (
			$.get(el),
			$_viewDates(),
			$scrollTime()
		),
		() => {
			if ($.get(el)) {
				$_viewDates();
				$scrollTime();
				scrollToTime();
			}
		}
	);

	$.legacy_pre_effect_reset();
	$.init();

	var div = root$1();
	var div_1 = $.child(div);
	var div_2 = $.child(div_1);

	$.each(div_2, 5, $_viewDates, $.index, ($$anchor, date) => {
		var fragment = $.comment();
		var node = $.first_child(fragment);

		$.each(node, 1, () => $_dayTimes()[$.get(date).getTime()], $.index, ($$anchor, time) => {
			var div_3 = root_2();

			$.template_effect(() => $.set_class(div_3, $theme().line));
			$.append($$anchor, div_3);
		});

		$.append($$anchor, fragment);
	});

	$.reset(div_2);

	var node_1 = $.sibling(div_2, 2);

	$.each(node_1, 1, $_viewResources, $.index, ($$anchor, resource) => {
		Days($$anchor, {
			get resource() {
				return $.get(resource);
			}
		});
	});

	$.reset(div_1);
	$.reset(div);
	$.bind_this(div, ($$value) => $.set(el, $$value), () => $.get(el));

	$.template_effect(() => {
		$.set_class(div, $theme().body);
		$.set_class(div_1, $theme().content);
		$.set_class(div_2, $theme().lines);
	});

	$.event('scroll', div, handleScroll);
	$.append($$anchor, div);
	$.pop();
	$$cleanup();
}

var root = $.template(`<div><!> <div><!> <!></div></div>`);

function View($$anchor, $$props) {
	$.push($$props, false);

	const [$$stores, $$cleanup] = $.setup_stores();
	const $theme = () => $.store_get(theme, '$theme', $$stores);
	let { theme } = getContext('state');

	$.init();

	var div = root();
	var node = $.child(div);

	Sidebar(node, {});

	var div_1 = $.sibling(node, 2);
	var node_1 = $.child(div_1);

	Header(node_1, {});

	var node_2 = $.sibling(node_1, 2);

	Body(node_2, {});
	$.reset(div_1);
	$.reset(div);

	$.template_effect(() => {
		$.set_class(div, $theme().container);
		$.set_class(div_1, $theme().main);
	});

	$.append($$anchor, div);
	$.pop();
	$$cleanup();
}

var index = {
	createOptions(options) {
		// Common options
		options.buttonText.resourceTimelineDay = 'timeline';
		options.buttonText.resourceTimelineWeek = 'timeline';
		options.buttonText.resourceTimelineMonth = 'timeline';
		options.theme.expander = 'ec-expander';
		options.theme.main = 'ec-main';
		options.theme.times = 'ec-times';
		options.theme.container = 'ec-container';
		options.view = 'resourceTimelineWeek';
		options.views.resourceTimelineDay = {
			buttonText: btnTextDay,
			component: View,
			displayEventEnd: false,
			dayHeaderFormat: { weekday: 'long' },
			duration: { days: 1 },
			slotDuration: '01:00',
			theme: themeView('ec-timeline ec-resource-day-view'),
			titleFormat: { year: 'numeric', month: 'long', day: 'numeric' }
		};
		options.views.resourceTimelineWeek = {
			buttonText: btnTextWeek,
			component: View,
			displayEventEnd: false,
			duration: { weeks: 1 },
			slotDuration: '01:00',
			theme: themeView('ec-timeline ec-resource-week-view')
		};
		options.views.resourceTimelineMonth = {
			buttonText: btnTextMonth,
			component: View,
			displayEventEnd: false,
			dayHeaderFormat: {
				weekday: 'short',
				day: 'numeric'
			},
			duration: { months: 1 },
			slotDuration: { days: 1 },
			theme: themeView('ec-timeline ec-resource-month-view'),
			titleFormat: { year: 'numeric', month: 'long' }
		};
	},

	createStores(state) {
		if (!('_viewResources' in state)) {
			state._viewResources = viewResources(state);
		}
		state._headerEl = writable(undefined);
		state._dayTimeLimits = dayTimeLimits(state);  // flexible time limits per day
		state._dayTimes = dayTimes(state);
		state._nestedResources = nestedResources(state);
		state._resHs = writable(new Map());  // resource row heights
		state._sidebarEl = writable(undefined);
	}
};

export { index as default };
